import { EmptyState } from '@/design'

import { NOT_AVAILABLE_TEXT } from './definitions'

/*
 * The empty states the overview's cards share: a range the overview has no figures for,
 * and the advertising flag off.
 */

/** The overview's figures are not available for the range (`needs_ad_platform`, the only reason). */
export function NotAvailable() {
  const text = NOT_AVAILABLE_TEXT.needs_ad_platform
  return <EmptyState variant="not-live" compact title={text.label} description={text.why} />
}

/**
 * The flag is off (a `404 not_found`): the page replaces every section with "not enabled"
 * once the overview answers; until then a section says the same, never an outage.
 */
export function FlagOffNote() {
  return (
    <EmptyState
      variant="permission"
      compact
      title="Meta advertising is not enabled"
      description="This workspace does not have Meta advertising reporting turned on."
    />
  )
}
